import ErrorComponent from "components/shared/ErrorComponent";
import Loader from "components/shared/Loader";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { useFetchContentQuery } from "store/services/user.service";

const AboutTab = () => {
  const { data: aboutUsContent, isLoading, isError } = useFetchContentQuery("ABOUT_US");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (aboutUsContent) {
      setContent(aboutUsContent.content);
    }
  }, [aboutUsContent]);

  return (
    <div className="inner">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ): isError ? (
            <ErrorComponent />
          ): (
            <div className="contentSec">
              <div
                className="m-0 text-muted py-2"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AboutTab;
